import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="confirmation"
export default class extends Controller {
  static targets = ['input', 'button'];

  connect() {
    this.check()
  }

  check() {
    const disabled = this.inputTargets.some((input) => {
      return input.checked === false
    })

    this.buttonTarget.disabled = disabled
  }
}
